module.exports = __webpack_public_path__ + "b13b27b2929af0f09ac30e1555c9fea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-thank-you.png
// module id = 2033
// module chunks = 4